import React, { memo, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import _debounce from 'lodash/debounce'
import { toast } from 'react-toastify'

/* services */
import LocationService from 'services/LocationService'

/* components */
import Select from 'components/ui/Select/Base'

/* styles */
import classes from './LocationSearch.module.scss'
import { useLanguage } from '../../../hooks/useLanguage'

const LocationSearch = ({
  label,
  placeholder,
  location,
  onChange,
  debounceTime,
  className,
  error,
  labelColor,
  // isNotRequired,
  inputId,
  name,
  onBlur,
  requiredField,
}) => {

  const { currentLanguage: { code: lang } } = useLanguage()

  const [locationSuggestions, setLocationSuggestions] = useState([])

  const lookupLocations = useCallback(
    _debounce((location) => {
      LocationService.search(location, lang)
        .then((data) => {
          // if (isNotRequired) data.push({ value: null, display_name: 'None' })
          const uniqueLocations = data.filter((location, index, self) => index === self.findIndex((l) => l.display_name === location.display_name))
          setLocationSuggestions(uniqueLocations)
        })
        .catch(() => {
          toast.error('Location search error')
        })
    }, debounceTime),
    [location, lang],
  )

  const onLocationInputChange = (text) => {
    lookupLocations(text)
  }

  const onValueChange = useCallback((value, name) => {
    onChange(value, name)
  }, [onChange])

  const getOptionLabel = (option) => (option && option.display_name ? option.display_name : '')
  const getOptionValue = (option) => (option && option.osm_id ? option.osm_id : null)

  const customStyles = {
    singleValue: (provided, state) => {
      const display = state.selectProps.menuIsOpen ? 'none' : 'block'

      return { ...provided, display }
    },
  }
  return (
    <Select
      styles={customStyles}
      name={name}
      inputId={inputId}
      onBlur={onBlur}
      label={label}
      placeholder={placeholder}
      labelColor={labelColor || classes.label}
      className={className}
      value={location}
      options={locationSuggestions}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      onInputChange={onLocationInputChange}
      onChange={onValueChange}
      error={error}
      requiredField={requiredField}
      dropdownIndicator
    />
  )
}

LocationSearch.propTypes = {
  location: PropTypes.shape({
    osm_id: PropTypes.number,
    display_name: PropTypes.string,
    lng: PropTypes.string,
    lat: PropTypes.string,
  }),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  debounceTime: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.any,
  // isNotRequired: PropTypes.bool,
}

LocationSearch.defaultProps = {
  name: '',
  label: 'location',
  placeholder: 'locationSearchPlaceHolder',
  debounceTime: 500,
  className: '',
  onChange: () => {},
}

export default memo(LocationSearch)
